import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "full flex flex-row cursor-pointer" }
const _hoisted_3 = {
  key: 0,
  class: "text-xl text-red-600"
}
const _hoisted_4 = { class: "flex-grow self-center h-full w-full" }
const _hoisted_5 = { class: "text-black font-thin text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "flex flex-row relative",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "*"))
        : _createCommentVNode("", true),
      _createVNode(_component_Icon, {
        id: "ck_icon",
        source: _ctx.image,
        width: _ctx.checkbox_width
      }, null, 8, ["source", "width"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ], 8, _hoisted_1))
}